import React from "react";
import './Login.css'
import { Link } from "react-router-dom";
import logo from '../images/logo.png'

function Login (){

    return(
       <div className="login">
            <div className="container">
               <div className="logo">                       
                    <img src={logo} />
                    <h2>D-Clinic</h2>
                </div>
                <form>
                   <div className="form">
                       <input placeholder="Username" type="text"required/>
                   </div>
                   <div className="form">
                       <input placeholder="Password" type="password"required/>
                   </div>
                   <Link to="/home" ><button className="btn1">Login</button></Link>
                   <br/>
                   <p>Dont have any account?</p>
                   <Link to="/signup" ><button className="btn2">Sign Up</button></Link>
               </form>
           </div>
       </div>
    )
}
export default Login;